import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';


//Row Height Estimation
function estimateRowHeight(entry) {
    const longestField = Math.max(
        (entry.method || '').length,
        (entry.topic || '').length,
        (entry.linktocode || '').length,
        (entry.linktostandards || '').length
    );

    const lines = Math.ceil(longestField / 15); // 50 chars per line is a safe wrap guess
    return lines * 15; // 15 is approx height per line
}

export const generateCPDExcel = async (filteredCPD, profile) => {
        try {
        // Load the template from public
        const response = await fetch('/CPDLogTemplate.xlsx');
        const arrayBuffer = await response.arrayBuffer();

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);
        const worksheet = workbook.worksheets[0];

        worksheet.getCell('A2').value = `${profile.first_name} ${profile.surname} (NMC PIN: ${profile.reval_members.nmc_pin})`;

        // Use existing phl state (passed in as prop or imported from context/state)
        filteredCPD.forEach((entry, idx) => {
        const row = worksheet.getRow(idx + 5); // Row 1 is headers
        row.values = [
            entry.date,
            entry.method,
            entry.topic,
            entry.linktocode,
            entry.linktostandards,
            entry.hours,
            entry.participatoryhours,
        ];

        row.height = estimateRowHeight(entry);

        row.eachCell((cell) => {
            cell.alignment = { wrapText: true, vertical: 'top', horizontal: 'left' };
            cell.border = {
                left: { style: 'thin'},
                bottom: { style: 'thin'},
                right: { style: 'thin'}
            }
        });

        row.commit();
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `${profile.first_name}_${profile.surname}_CPDLog.xlsx`;
            return { buffer, fileName };
        } catch (err) {
            console.error('Error generating PHL Excel:', err);
            return null;
        }
    };

export const downloadCPDExcelDirect = async (filteredCPD, profile) => {
  const result = await generateCPDExcel(filteredCPD, profile);
  if (result) {
    const blob = new Blob([result.buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, result.fileName);
  }
};